import { Tooltip } from '@material-ui/core'
import Button from '@material-ui/core/Button'
import Chip from '@material-ui/core/Chip'
import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import { withStyles } from '@material-ui/core/styles'
import { PlaceOutlined } from '@material-ui/icons'
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined'
import ZoomInIcon from '@material-ui/icons/ZoomIn'
import ZoomOutIcon from '@material-ui/icons/ZoomOut'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import React, {useState, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import 'react-table/react-table.css'
import {
    PLACEHOLDER_IMAGE,
    SCALE_VALUES,
    IMAGE_STATE_NOT_LOADED,
    IMAGE_VIEW_KEYS,
    IMAGE_VIEW_CONVERT,
    MAP_URL,
} from '../../../Constants'
import ModalDialog from '../../../fhg/components/dialog/ModalDialog'
import Typography from '../../../fhg/components/Typography'
import { RotateIcon, ZoomIcon } from '../../../Icons'
import ErrorSnackbar from '../components/ErrorSnackbar'
import ImageComponent from '../components/ImageComponent'
import PhotoCategorySelect from '../components/PhotoCategorySelect'
import '../dashboard/EvalDashboardTable'
import { SuccessCheck } from '../list/UploadPhotoSummary2'
import PhotoHeader from './PhotoHeader'
import ThumbnailList from './ThumbnailList'
import IMSForm from './IMSForm/IMSForm2'
import withSelectedCategory from '../list/withSelectedCategory'
import withIsTabClicked from './WithIsTabClicked'
import useEquipmentImageDetail from './useEquipmentImageDetail'
import { circularProgress } from '@material-ui/core'
import DownloadIcon from '@material-ui/icons/GetApp'
import { makeStyles } from '@material-ui/core/styles'
import { getUserData } from '../../../Utils/ServerUtil'
import { extractImageUrlFromVariants } from '../../../fhg/utils/Utils'

const styles = (theme) => ({
    root: {
        display: 'flex',
        flex: '1 1',
        maxWidth: '100%',
        overflow: 'hidden',
    },
    progress: {
        position: 'fixed',
        top:
            theme.mixins.toolbar.minHeight +
            theme.spacing(8) +
            10,
        left: 10,
        zIndex: 1001,
    },
    image: {
        '&:after': {
            content: '""',
            position: 'absolute',
            top: 2,
            left: 2,
            right: 2,
            bottom: 2,
            border: `4px solid ${theme.palette.action.selectedDark}`,
            zIndex: 1001,
        },
    },
    titleBar: {
        background:
            'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
    },
    moreTitleBar: {
        background: 'transparent',
    },
    titleText: {
        fontSize: `${theme.size.font['item-title']}rem`,
        lineHeight: `${theme.size.lineheight['item-title']}rem`,
        letterSpacing: `${theme.size.letterspacing['item-title']}rem`,
    },
    placesicon: {
        color: 'white !important',
    },
    buttonRotate: {
        composes: 'no-print',
        zIndex: 1001,
        position: 'absolute',
        right: theme.spacing(2),
        top: theme.spacing(2),
        textTransform: 'none',
        borderRadius: 4,
        padding: `${theme.spacing(0.75)}px !important`,
        color: '#ffff !important',
        backgroundColor: '#4f2682 !important',
        '-webkit-filter': 'drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.2))',
        filter: 'drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.2))',
        '&:hover': {
            backgroundColor: '#7743b8 !important',
        },
    },
    chipStyle: {
        composes: 'contrast-text-small',
        zIndex: 1001,
        position: 'absolute',
        right: theme.spacing(2),
        bottom: theme.spacing(1),
        backgroundColor: 'rgba(255,255,255,0.8)',
        height: 29,
        '-webkit-filter': 'drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.2))',
        filter: 'drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.2))',
        '& > svg': {
            height: 'calc(100% - 6px)',
            left: 5,
            position: 'relative',
        },
    },
    buttonOutline: {
        zIndex: 1001,
        position: 'absolute',
        right: theme.spacing(2),
        top: theme.spacing(2),
        textTransform: 'none',
        color: theme.palette.button.standard.secondary,
        backgroundColor: theme.palette.environment.light.level0.base,
        '-webkit-filter': 'drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.2))',
        filter: 'drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.2))',
        '&:hover': {
            backgroundColor: theme.palette.environment.light.level0.base,
        },
    },
    fullImage: {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        position: 'relative',
        userSelect: 'none',
    },
    imageFrame: {
        margin: 'auto',
    },
    zoomInButton: {
        color: 'white',
        height: 40,
        borderRadius: '0% 10% 10% 0%;',
        backgroundColor: theme.palette.button.standard.secondary,
        '&:hover': {
            backgroundColor: theme.palette.button.standard.secondary,
        },
    },
    zoomOutButton: {
        color: 'white',
        height: 40,
        borderRadius: '10% 0% 0% 10%;',
        backgroundColor: theme.palette.button.standard.secondary,
        '&:hover': {
            backgroundColor: theme.palette.button.standard.secondary,
        },
    },
    zoomResetButton: {
        color: 'white',
        height: 40,
        borderRadius: '0%',
        backgroundColor: theme.palette.button.standard.secondary,
        '&:hover': {
            backgroundColor: theme.palette.button.standard.secondary,
        },
    },
    zoomPanel: {
        zIndex: 1001,
        position: 'absolute',
        bottom: theme.spacing(1),
        left: 'calc(50% - 100px)',
        whiteSpace: 'nowrap',
    },
    icon: {
        color: 'white',
    },
    imageType: {
        marginLeft: 4,
    },
})

const useStyles = makeStyles((theme) => ({
    buttonRotate: {
        zIndex: 1001,
        // position: 'absolute',
        // right: theme.spacing(2),
        // top: theme.spacing(2),
        textTransform: 'none',
        borderRadius: 4,
        padding: `${theme.spacing(0.75)}px !important`,
        color: '#fff !important',
        backgroundColor: '#4f2682 !important',
        filter: 'drop-shadow(0px 1px 3px rgba(0, 0, 0, 0.2))',
        '&:hover': {
            backgroundColor: '#7743b8 !important',
        },
    },
    placesicon: {
        color: 'white !important',
    },
}))

const EquipmentImageDetail = (props) => {
    const {
        isError,
        evaluation,
        onBack,
        evalItem,
        selectedCategory,
        children,
        isTabClicked,
    } = props

    // console.log({selectedCategory, evalItem, evaluation})

    const {
        // State
        selectedImage,
        images,
        imageWidth,
        imageHeight,
        isZoomed,
        scale,
        isScaledLocation,
        thumbColumns,
        showConfirmDelete,
        selected,
        showCategorySelect,
        refreshThumbnails,
        showError,
        errorValues,
        deletePhoto,
        
        // Computed
        allowRotateComputed,
        allowZoomComputed,
        thumbnailsSelected,
        useAnimation,
        
        // Functions
        selectImage,
        onClick,
        onWheel,
        onZoomClick,
        onZoomInClick,
        onZoomOutClick,
        onZoomResetClick,
        onRotateClick,
        handleConfirmDeletePhoto,
        handleCloseConfirmDeletePhoto,
        handleDeletePhoto,
        handleCategorizePhoto,
        closeCategorizePhoto,
        handleThumbnailSelect,
        handleCancelSelection,
        handleMovePhoto,
        handleSortPhotos,
        handleErrorClose,
        handleRefresh,
        onPhotoRecategorizeRefresh,
        onError,
        getSelectedImages,
        
        // Refs
        imageRef,
        imageGridRef,
        mainRef
    } = useEquipmentImageDetail(props)

    // Get image properties
    let selectedImageUrl = extractImageUrlFromVariants(selectedImage, 'original') || PLACEHOLDER_IMAGE
    const latitude = get(selectedImage, 'latitude')
    const longitude = get(selectedImage, 'longitude')
    const rotation = selectedImage.__rotation || 0
    let imageTop
    
    // Determine variant type from selectedImage.variants array
    const variants = get(selectedImage, 'variants', [])
    let variantType = 'low-res' // default fallback
    
    if (variants.length > 0) {
        // Check for hi-res first (priority), then low-res
        const hiResVariant = variants.find(variant => variant.type === 'hi-res')
        const lowResVariant = variants.find(variant => variant.type === 'low-res')
        
        if (hiResVariant) {
            variantType = 'hi-res'
        } else if (lowResVariant) {
            variantType = 'low-res'
        }
    }

    if (rotation % 180 !== 0) {
        imageTop = (imageWidth - imageHeight) / 2
    }

    const imageSource = selectedImage.image_source
    const isVerified = imageSource && imageSource !== 'unknown'
    let verifiedAvatar = isVerified ? <SuccessCheck /> : undefined
    const hasLocation = latitude && longitude
    //const classes = useStyles()
    const [isDownloading, setIsDownloading] = useState(false)
    const classes = useStyles()

    const handleDownload = async (e) => {
        e.stopPropagation()
        setIsDownloading(true)

        try {
            const response = await fetch(selectedImageUrl, { mode: 'cors' })
            if (!response.ok) throw new Error('Image fetch failed')

                const filename =
                                    selectedImage.original_filename ||
                                    `image-${selectedImage.image_id}`

            const blob = await response.blob()
            const url = window.URL.createObjectURL(blob)

            const link = document.createElement('a')
            link.href = url
            link.download = filename
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(url)
        } catch (err) {
            console.error('Download failed:', err)
        } finally {
            setIsDownloading(false)
        }
    }
// console.log({selectedImage});

    return (
        <Fragment>
            {showError && (
                <ErrorSnackbar
                    open={true}
                    errorId={'photoDetail.delete.error'}
                    values={errorValues}
                    enableRefresh={false}
                    onClose={handleErrorClose}
                />
            )}
            {showConfirmDelete && (
                <ModalDialog
                    open={showConfirmDelete}
                    onClose={handleCloseConfirmDeletePhoto}
                    onSubmit={handleDeletePhoto(deletePhoto)}
                    messageKey={'photoDetail.delete.confirm'}
                    values={{ count: thumbnailsSelected || 1 }}
                    titleKey={'photoDetail.delete.confirm.title'}
                    titleValues={{ count: thumbnailsSelected || 1 }}
                    maxWidth={'xs'}
                    submitKey={'delete.button'}
                    submitColorStyle={'destroy-button'}
                    cancelColorStyle={'secondary-color'}
                />
            )}
            {showCategorySelect && (
                <PhotoCategorySelect
                    onClose={closeCategorizePhoto}
                    images={getSelectedImages(selected, images)}
                    onRefresh={onPhotoRecategorizeRefresh}
                />
            )}
            {thumbnailsSelected > 0 && (
                <PhotoHeader
                    onBack={onBack}
                    evaluation={evaluation}
                    thumbnailsSelected={thumbnailsSelected}
                    onDelete={handleConfirmDeletePhoto()}
                    onCancel={handleCancelSelection}
                    onCategorize={handleCategorizePhoto}
                    onSort={handleSortPhotos}
                />
            )}
            <Grid
                container
                className={classes.root}
                spacing={0}
                justifyContent={'flex-end'}
                wrap={'nowrap'}
                direction={'row'}
                ref={mainRef}
            >
                <Grid
                    item
                    style={{
                        flex: '1 1 100%',
                        overflow: 'hidden',
                        position: 'relative',
                    }}
                    ref={imageGridRef}
                >
                    {children}
                    
                    {
                        !isZoomed ? (
                            <div style={{
                                top: 10,
                                left: 10,
                                position: 'absolute',
                                zIndex: 99999,
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: "center",
                                width: '100%',
                                zIndex: 2,
                            }}>
                                <Chip
                                    className={classes.chipStyle}
                                    label={
                                        <Typography
                                            id={
                                                IMAGE_VIEW_KEYS[
                                                    selectedImage.image_view
                                                ] ||
                                                IMAGE_VIEW_KEYS[
                                                    IMAGE_VIEW_CONVERT[
                                                        selectedImage.image_view
                                                    ]
                                                ] ||
                                                selectedImage.image_view ||
                                                'photoDetail.changeCategory.additional'
                                            }
                                            className={classes.imageType}
                                        />
                                    }
                                    avatar={verifiedAvatar}
                                />

                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '0.5rem',
                                    paddingRight: '0.75rem'
                                }}>
                                    { getUserData().isAdmin && (<IconButton
                                        className={classes.buttonRotate}
                                        style={{
                                            color: 'white',
                                            backgroundColor: isDownloading ? '#555555' : 'transparent',
                                        }}
                                        disabled={isDownloading}
                                        onClick={handleDownload}
                                    >
                                        <Tooltip title={isDownloading ? 'Downloading...' : 'Download Image'}>
                                            {isDownloading ? (
                                                <CircularProgress size={24} color="inherit" />
                                            ) : (
                                                <DownloadIcon className={classes.placesicon} />
                                            )}
                                        </Tooltip>
                                    </IconButton>)}
                                    {hasLocation && (
                                        <IconButton
                                            name="LocationUrl"
                                            target="_blank"
                                            href={MAP_URL.format({ latitude, longitude })}
                                            variant={'text'}
                                            className={classes.buttonRotate}
                                            style={{ color: 'white' }}
                                        >
                                            <Tooltip title={`${latitude}, ${longitude}`}>
                                                <PlaceOutlined
                                                    className={classes.placesicon}
                                                />
                                            </Tooltip>
                                        </IconButton>
                                    )}
                                    {allowRotateComputed && (
                                        <IconButton
                                            variant={'text'}
                                            className={classes.buttonRotate}
                                            onClickCapture={onRotateClick}
                                        >
                                            <RotateIcon />
                                        </IconButton>
                                    )}
                                    {allowZoomComputed && (
                                        <IconButton
                                            variant={'text'}
                                            className={classes.buttonRotate}
                                            onClickCapture={onZoomClick}
                                        >
                                            <ZoomIcon />
                                        </IconButton>
                                    )}
                                </div>
                            </div>
                        ) :  (
                            <div style={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                justifyContent: 'space-between', 
                                flexDirection: 'row-reverse',
                                padding: '0.25rem 0.5rem',
                                zIndex: 2,
                                position: 'relative'
                            }}>
                                <IconButton
                                    variant={'text'}
                                    className={classes.buttonOutline}
                                    onClickCapture={onZoomClick}
                                    style={{
                                        background: 'gray',
                                        color: 'white'
                                    }}
                                >
                                    <CloseOutlinedIcon />
                                </IconButton>

                                <div className={classes.zoomPanel}>
                                    <IconButton
                                        variant={'text'}
                                        aria-label="Zoom and Pan"
                                        className={classes.zoomOutButton}
                                        onClickCapture={onZoomOutClick}
                                        disabled={scale <= SCALE_VALUES[0]}
                                        style={{
                                            background: 'rgba(8, 8, 8, 0.30)',
                                            color: 'white'
                                        }}
                                        size='small'
                                    >
                                        <ZoomOutIcon/>
                                    </IconButton>
                                    <Button
                                        variant={'text'}
                                        aria-label="Zoom and Pan"
                                        className={classes.zoomResetButton}
                                        onClickCapture={onZoomResetClick}
                                    >
                                        {Number(scale * 100).toFixed(0)}%
                                    </Button>
                                    <IconButton
                                        variant={'text'}
                                        aria-label="Zoom and Pan"
                                        className={classes.zoomInButton}
                                        onClickCapture={onZoomInClick}
                                        disabled={
                                            scale >=
                                            SCALE_VALUES[SCALE_VALUES.length - 1]
                                        }
                                        style={{
                                            background: 'rgba(8, 8, 8, 0.30)',
                                            color: 'white'
                                        }}
                                        size='small'
                                    >
                                        <ZoomInIcon/>
                                    </IconButton>
                                </div>
                            </div>
                        )
                    }

                    {!isError &&
                        selectedImage.__state === IMAGE_STATE_NOT_LOADED && (
                            <CircularProgress
                                className={classes.progress}
                            />
                        )
                    }

                    <div
                        className={classes.imageFrame}
                        style={{ 
                            width: imageWidth, 
                            height: 'calc(100vh - 345px)', 
                            position: 'relative' 
                        }}
                        onWheel={onWheel}
                    >
                        <ImageComponent
                            className={classes.fullImage}
                            ref={imageRef}
                            src={selectedImageUrl}
                            rotation={rotation}
                            scale={scale}
                            variantType={variantType}
                            useAnimation={useAnimation}
                            onClick={onClick}
                            isScaledLocation={isScaledLocation}
                            top={imageTop}
                            isZoomed={isZoomed}
                            onError={onError(selectedImage)}
                        />
                    </div>

                    <ThumbnailList
                        selectedImage={selectedImage}
                        images={images}
                        selected={selected}
                        onDeletePhoto={handleConfirmDeletePhoto}
                        onRefresh={handleRefresh}
                        thumbColumns={thumbColumns}
                        onSelect={selectImage}
                        onSelectThumbnail={handleThumbnailSelect}
                        refresh={refreshThumbnails}
                        onMovePhoto={handleMovePhoto}
                        onSortAllPhotos={handleSortPhotos}
                        evalItem={evalItem}
                    />
                </Grid>
                
                {isTabClicked && (
                    <Grid item>
                        <IMSForm
                            selectedCategory={selectedCategory}
                            evalItem={evalItem}
                            evaluation={evaluation}
                            itemData={evalItem?.itemData}
                        />
                    </Grid>
                )}
            </Grid>
        </Fragment>
    )
}

EquipmentImageDetail.propTypes = {
    classes: PropTypes.any.isRequired,
    match: PropTypes.object.isRequired,
    evalItem: PropTypes.object,
    allowRotate: PropTypes.bool,
    allowZoom: PropTypes.bool,
    onZoom: PropTypes.func,
    onRefresh: PropTypes.func,
    isError: PropTypes.bool,
    evaluation: PropTypes.object,
}

EquipmentImageDetail.defaultProps = {
    allowRotate: true,
    allowZoom: true,
    isError: false,
}

export default withRouter(
    withStyles(styles)(
        withIsTabClicked(withSelectedCategory(EquipmentImageDetail))
    )
)